import { DateTime } from 'luxon';
import { AssessmentEventSource } from '~/analytics/assessmentEvents';

export const calculateDaysLeftIn30DayWindowFromAdmitDate = (
  createdDateStr: string | null,
  admitDateStr: string | null,
) => {
  const createdDate = DateTime.fromISO(createdDateStr, {
    zone: 'America/New_York',
  }).startOf('day');
  const now = DateTime.now().setZone('America/New_York').startOf('day');
  const admitDate = DateTime.fromISO(admitDateStr, {
    zone: 'America/New_York',
  }).startOf('day');

  if (!createdDateStr || !createdDate.isValid) {
    return 0;
  }

  // Means the admit date has already passed, so assume normal 30 day window.
  const hasAdmitDatePassed = admitDate < createdDate;
  if (!admitDateStr || !admitDate.isValid || hasAdmitDatePassed) {
    const daysSinceCreated = now.diff(createdDate, 'days').days;
    const daysLeft = Math.max(0, 30 - daysSinceCreated);
    return daysLeft;
  }

  // Otherwise, the first time overdue assessment should be offset by the difference between admit date and created date.
  const daysBetweenAdmitAndCreated = admitDate.diff(createdDate, 'days').days;
  const totalWindowDays = 30 + daysBetweenAdmitAndCreated;

  const daysSinceCreated = now.diff(createdDate, 'days').days;
  const daysLeft = Math.max(0, totalWindowDays - daysSinceCreated);

  return daysLeft;
};

// estimatedDuration is seeded per survey as a display string ('7 minutes',
// '30-45 minutes'). Figma abbreviates the unit to keep it on one line in the rail.
export const abbreviateAssessmentDuration = (
  estimatedDuration?: string,
): string | undefined => estimatedDuration?.replace(/\bminutes?\b/i, 'min');

export const getAssessmentEventSource = (pathname: string): string => {
  if (pathname.match(/\/maud\/surveys\/[^/]+$/)) {
    return AssessmentEventSource.EditPatientNoteForm;
  }

  if (pathname.match(/\/maud\/patients\/[^/]+\/assessments$/)) {
    return AssessmentEventSource.AssessmentCards;
  }

  if (pathname.match(/\/maud\/patients\/[^/]+(?:\/overview)?$/)) {
    return AssessmentEventSource.PatientOverviewTab;
  }

  return 'Unknown';
};
